import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { linkListStyles } from "@insite/content-library/Widgets/Basic/SocialLinks";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    logoGridItem?: GridItemProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
    footerContentWrapper?: InjectableCss;
    copyContentWrapper?: InjectableCss;
    copyrightWrapper?: InjectableCss;
    socialLinksWrapper?: InjectableCss;
}

linkListStyles.socialLinkListWrapper = {
    css: css`
        width: 100%;
        padding: 10px 0;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        justify-content: flex-start;
        padding: 0;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding: 5px 0 30px;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            );
        }}
        > div {
            max-width: 20px;
            width: 20px;
            padding: 0;
            margin-right: 25px;
            &:last-child {
                margin-right: 5px;
            }
            a {
                &:hover {
                    span {
                        svg {
                            fill: #fff;
                            stroke: none;
                        }
                    }
                }
            }
        }
    `,
};

export const footerContainerStyles: FooterContainerStyles = {
    widgetGridContainer: {
        css: css`
            max-width: 100% !important;
            > div {
                max-width: 100%;
                margin: 0 auto;
                align-items: center;
            }
        `,
    },
    logoGridItem: {
        width: 12,
        css: css`
            width: 100%;
            display: flex;
            justify-content: center;
            img {
                height: 78px;
            }
        `,
    },
    linkList1GridItem: {
        width: 12,
        css: css`
            background: ${getColor("primary")};
            padding: 35px 0 15px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        padding: 30px 0 20px;
                    `,
                    null,
                    null,
                ]);
            }}
        `,
    },
    linkList2GridItem: {
        width: 12,
        css: css`
            background: #18243d;
            padding: 15px 0 0 0;
        `,
    },
    linkList3GridItem: {
        width: [6, 6, 6, 6, 6],
        css: css`
            background: #18243d;
        `,
    },
    linkList4GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    subscribeGridItem: {
        width: [12, 12, 8, 4, 4],
    },
    socialLinksGridItem: {
        width: 12,
    },
    siteMapLinksGridItem: {
        width: 12,
    },
    richContentGridItem: {
        width: 12,
    },
    logoWrapper: {
        css: css`
            width: 110px;
        `,
    },
    footerContentWrapper: {
        css: css`
            max-width: 1440px;
            width: 100%;
            margin: 0 auto;
            display: flex;
            color: #fff;
            align-items: center;
            padding: 0 15px;
            div[class^="GridOffset"] {
                max-width: 100%;
            }
            a,
            span {
                font-size: 17px;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                font-size: 14px;
                            `,
                            null,
                        ],
                        "max",
                    );
                }}
            }
            .footerContact {
                a {
                    margin-bottom: 10px;
                    span {
                        font-size: 34px;
                        line-height: 28px;
                    }
                    span {
                        color: #fff;
                        font-weight: 600;
                        text-transform: uppercase;
                    }
                    &:hover {
                        span {
                            color: #fff;
                            opacity: 0.7;
                        }
                    }
                }
            }
            .footerLast {
                align-items: center;
                justify-content: flex-end;
                width: 100%;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            margin-top: 10px !important;
                        `,
                        null,
                        null,
                    ]);
                }}
            }
            .iconTxtWrapper {
                display: inline-flex;
                align-items: center;
                height: 40px;
                width: 100%;
                justify-content: flex-end;
                a {
                    span[class^="TypographyStyle"] {
                        display: flex;
                        align-items: center;
                        span {
                            color: #fff;
                            &.linkTxt {
                                margin-left: 20px;
                            }
                        }
                    }
                    &:hover {
                        span.linkTxt {
                            text-decoration: underline;
                        }
                    }
                }
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                justify-content: flex-start;
                            `,
                            null,
                            css`
                                font-size: 13px;
                            `,
                            null,
                        ],
                        "max",
                    );
                }}
                > span[class^="LazyImageStyle"] {
                    margin-right: 20px;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    img {
                                        max-width: 22px;
                                    }
                                `,
                                null,
                                css`
                                    margin-right: 10px;
                                `,
                                null,
                            ],
                            "max",
                        );
                    }}
                }
                &.phone {
                    padding-right: 20px;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    padding-right: 0;
                                    justify-content: flex-end;
                                `,
                                css`
                                    padding-right: 0;
                                    justify-content: flex-start;
                                `,
                                css`
                                    padding-left: 20px;
                                `,
                            ],
                            "min",
                        );
                    }}
                }
            }
        `,
    },
    copyContentWrapper: {
        css: css`
            width: 100%;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            flex-direction: column;
                            text-align: center;
                        `,
                        css`
                            display: flex;
                            flex-direction: row;
                        `,
                        null,
                        null,
                    ],
                    "min",
                );
            }}
        `,
    },
    copyrightWrapper: {
        css: css`
            width: 50%;
            opacity: 0.6;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 70%;
                            display: inline-flex;
                        `,
                        null,
                        null,
                    ],
                    "min",
                );
            }}
            .copyright {
                font-size: 13px;
                p {
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    text-align: center;
                                `,
                                css`
                                    text-align: center;
                                `,
                                css`
                                    text-align: left;
                                `,
                                null,
                                null,
                            ],
                            "min",
                        );
                    }}
                }
                a,
                span {
                    font-size: 13px;
                    color: #fff;
                    margin: 0 4px;
                }
                a:hover {
                    span {
                        color: #fff;
                        text-decoration: underline;
                    }
                }
            }
        `,
    },
    socialLinksWrapper: {
        css: css`
            width: 50%;
            opacity: 0.6;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 30%;
                            display: inline-flex;
                        `,
                        null,
                        null,
                    ],
                    "min",
                );
            }}
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <GridContainer {...styles.widgetGridContainer}>
            <GridItem {...styles.linkList1GridItem}>
                <StyledWrapper {...styles.footerContentWrapper}>
                    <Zone zoneName="contactUs" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.linkList2GridItem}>
                <StyledWrapper {...styles.footerContentWrapper}>
                    <StyledWrapper {...styles.copyContentWrapper}>
                        <StyledWrapper {...styles.copyrightWrapper}>
                            <Zone zoneName="copyright" contentId={id} />
                        </StyledWrapper>
                        <StyledWrapper {...styles.socialLinksWrapper}>
                            <Zone zoneName="socialLinks" contentId={id} />
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </GridItem>
        </GridContainer>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
